import { SerializedError } from '@reduxjs/toolkit'

import {PhotoInfo} from './resident';

export interface TenantState {
    records: Array<TenantData>
    systemUsers: SystemUser[]
    loading: 'idle' | 'pending' | 'succeeded' | 'failed'
    error: SerializedError | null
}

export interface CreateTenantData {
    data: {
        id: string,
        name: string,
        companyLogo?: string,
        accountInfo: {
            email: string
            firstName: string
            lastName: string
            welcomeNotification: boolean
            language: string
            resetUrl: string
        }
    }
    photo?: PhotoInfo
}

export interface UpdateTenantData {
    data: TenantData;
    photo?: PhotoInfo
}

export interface Acknowledgement {
    date: string;
    message: string;
    hyperlink?: string;
    jurisdictions?: string[];
    checkedDate?: string;
    facility?: {
        id: string,
        name: string
    };
}


export interface TenantSettings {
    disablePinAuthentication?: boolean;
    disablePasswordAuthentication?: boolean;
}

export enum SSOAuthType {
    EntraID='EntraID',
}

export interface SSOAuthProviderConfig {
    authType: SSOAuthType;
    externalTenantId: string;
}

export interface TenantData {
    id?: string,
    tenant: string
    name: string,
    companyLogo?: string,
    staffMembers?: StaffMember[],
    supervisors?: StaffMember[],
    staffAcknowledgements?: Acknowledgement[],
    reportsSettings?: ReportsSettings
    settings?: TenantSettings;
    ssoAuthProviders?: SSOAuthProviderConfig[];
}

export interface StaffMember {
    id?: string;
    email: string;
    pinCode: string;
    staffId: string;
    firstName: string;
    lastName: string;
    position: string;
    role: string;
    photo?: string;
    facility?: {
        id: string;
        name: string;
    };
    isArchived?: boolean;
    isAuthenticationActive: boolean;
    createdDate?: string;
    modifiedDate?: string;
    /** Specifies the restricted filter which will be applied to rooms dashboard, 
     * If it is specified then area filter is hidden for the staff member */
    restrictedArea?: string,
    /** Specifies selected AssignmentTemplate for the RestrictedArea */
    restrictedAreaAssignmentId?: string,
    disableNotifications?: boolean;
}

export interface ReportsSettings {
    enhancedClean?: EnhancedCleanReportSettings;
}

export interface EnhancedCleanReportSettings {
    bgColor?: string;
    alternateBgColor?: string;
    headerBgColor?: string;
    headerTextColor?: string;
}

export interface SaveStaffRequest {
    data: {
        tenantId: string;
        staffMember: StaffMember;
        notificationInfo?: {
            language: string
            resetUrl: string
        }
    }
}

export interface SaveAcknowledgements {
    data: {
        tenantId: string;
        acknowledgements: Acknowledgement[]        
    }
}

export interface SaveOrganizationAcknowledgements {
    data: {
        tenantId: string;
        acknowledgements: Acknowledgement[]        
    }
}

export interface SaveFacilityAcknowledgements {
    data: {
        tenantId: string;
        facilityId: string;
        acknowledgements: Acknowledgement[]        
    }
}

export interface SystemUser {
    id: string;
    role?: string;
    email?: string;
}

export interface SaveSystemUser {
    data: {
        systemUser: SystemUser;
        notificationInfo?: {
            language: string
            resetUrl: string
        }      
    }
}

export interface DeleteSystemUser {
    data: {
        systemUser: SystemUser;
    }
}
